'use client'

import React, { useEffect, useState, useRef, useCallback } from "react";
import styled from "styled-components";
import moment from "moment";
import {convStlmDateString} from "util/DateUtils";
import * as httpService from "util/HttpService";
import { useTranslation } from "react-i18next";
import { callApi } from "util/HttpService";
import SelectBox from "components/web/UI/SelectBox";
import EqmtSelectBox from "components/mobile/cmmn/EqmtSelectBox";
import ButtonUtil from "components/mobile/UI/ButtonUtil";
import { getDateRangeForButton, getFormattedDate } from "util/DateSearchUtils";
import CustomDatePicker from "components/mobile/UI/DatePicker";
import { useWindowSize } from "context/WindowSizeContext";
import { useBrch } from "components/web/auth/BrchProvider";
import StlmRefundModal from "components/mobile/cmmn/StlmRefundModal";

//img
import Activity from 'asset/mobile_web/img/icon/filled/dashboard_b.svg';

const MainSection = styled.section`

  body {
    line-height: 1;
    font-size: 100%;
    overflow-x: hidden;
    box-sizing: border-box;
    font-family: "Noto Sans KR", sans-serif;
    font-size: 10px;
  }

  padding: 100px 20px 100px 20px;
  
`;

const DashBoardWrap = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 20px 0;

    .dashboard-box{
      background-color: #fff;
      border-radius: 16px;
      width: 100%;
      margin-bottom: 20px;
      box-shadow: 0 0 10px rgba(0,0,0,.1);
    }
    .stlm-box{
      padding: 20px;
      width: 100%;
      margin-bottom: 20px;
    }
    .stlm-box .stlm-title{
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
    .stlm-box .stlm-title .stlm-num{
      background-color: #EF2929;
      padding: 5px;
      border-radius: 4px;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: bold;
      color: #fff;
      margin-right: 10px;
    }
    .stlm-box .stlm-title h2{
      font-size: 16px;
      color: #3b3b3b;
      font-weight: 500;
      line-height: 150%;
    }
    .stlm-box .stlm-content{
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;
    }
    .stlm-box .stlm-content label{
      font-size: 16px;
      color: #8B8B8B;
      font-weight: 400;
      line-height: 150%;
      margin-left: 10px;
    }
    .stlm-box .stlm-content input[type="checkbox"]{
      margin: 5px 0;
    }
`;
const TitleWrap = styled.div`
  .title {
    display: flex;
    align-items: center;
    padding-bottom: 15px;
    border-bottom: 1px solid #d3d3d3;
    width: 100%;
  }
  .title img {
    width: 15px;
    margin-right: 10px;
  }
  .title h2 {
    font-size: 18px;
    color: #3b3b3b;
    font-weight: 500;
  }
`;
const SearchOptionWrap = styled.ul`
  li{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #EEEEEE;
  }
  
  li:last-of-type{
    border-bottom: none;
    margin-bottom: 10px;
  }
  
  li h3{
    font-size: 16px;
    color: #3b3b3b;
    font-weight: 500;
    min-width: 80px;
  }
  
  .dateSection {
    display:flex;
    flex-direction:column;
    justify-content: flex-start;
    gap:5px;
    h3 {
      margin-right: auto; 
    }
  }

`;

const StlmLnkgDtlBox = styled.div`

`;


export default function QrStlmMgt() {
    
    const { t } = useTranslation();
    const isMobile = useWindowSize();
    const { brchId } = useBrch();
    const now = moment();
    
    // 결제 리스트
    const [stlmList, setStlmList] = useState([]);

    // 검색 조건 데이터
    const defaultSearchData = {
        brchId: brchId,
        eqmtId: null,
        startDate: now.clone().startOf('day').format("YYYY-MM-DD"),
        endDate: now.clone().endOf('day').format("YYYY-MM-DD"),
        payYn: null, // 정상결제 여부 Y 시 촬영이력에 cutmId존재하는건 N 일시 촬영이력에 cutmId존재하지 않는건
        stlmStatCd: null,
        stlmMethCd: null
    };
    const [searchData, setSearchData] = useState(defaultSearchData);

    // 검색 조건 변경 함수
    const handleSearchDataChange = (event) => {
        const { name, value } = event.target;
        setSearchData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    /* 검색데이터 콘솔 조회 : 삭제예정
    useEffect(() => {
      console.log(searchData);
    },[searchData]);
    */

    // 결제 상태 코드 SelectBox 배열
    const stlmStatArr = [
      {key:t("qrStlmMgtPage.pending"), value:"pending"},
      {key:t("qrStlmMgtPage.waiting"), value:"waiting"},
      {key:t("qrStlmMgtPage.notified"), value:"notified"},
      {key:t("qrStlmMgtPage.uncaptured"), value:"uncaptured"},
      {key:t("qrStlmMgtPage.captured"), value:"captured"},
      {key:t("qrStlmMgtPage.partiallyRefunded"), value:"partially_refunded"},
      {key:t("qrStlmMgtPage.refunded"), value:"refunded"},
      {key:t("qrStlmMgtPage.amount_mismatch"), value:"amount_mismatch"},
      {key:t("qrStlmMgtPage.revoked"), value:"revoked"},
      {key:t("qrStlmMgtPage.failed"), value:"failed"},
    ];
    
    // 결제 상태 코드 언어화 노출하기위한 객체
    const stlmStatObj = {
      pending:t("qrStlmMgtPage.pending"),
      waiting:t("qrStlmMgtPage.waiting"),
      notified:t("qrStlmMgtPage.notified"),
      upcaptured:t("qrStlmMgtPage.uncaptured"),
      captured:t("qrStlmMgtPage.captured"),
      partially_refunded:t("qrStlmMgtPage.partiallyRefunded"),
      refunded:t("qrStlmMgtPage.refunded"),
      amount_mismatch:t("qrStlmMgtPage.amount_mismatch"),
      revoked:t("qrStlmMgtPage.revoked"),
      failed:t("qrStlmMgtPage.failed"),
    };

    // 결제 방법 코드 SelectBox 배열
    const stlmMethArr = [
      {key:"paypay", value:"paypay"},
      {key:"aupay", value:"aupay"},
      {key:"docomopay", value:"docomopay"},
      {key:"merpay", value:"merpay"},
      {key:"paidy", value:"paidy"},
      {key:"googlepay", value:"googlepay"},
      {key:"creditcard", value:"creditcard"},
      {key:"paypal", value:"paypal"},
      {key:"unionpay", value:"unionpay"},
    ];

    // 결제 리스트 호출 함수
    const getStlmList = () => {
      httpService.callApi("GET",searchData,"/web/api/svc-mgt/qr-lnkg/list")
      .then((res) => {
        //console.log(res);
        setStlmList(res);
      })
      .catch((err) => {
        console.log("Error fetching data:", err);
      });
    };


    // 첫 렌더링시 한번 결제 리스트 호출
    useEffect(() => {
      getStlmList();
    },[]);


    /* 공통 버튼 클릭 함수 */
    const handleCmmnBtnClick = (btnNm) => {
        switch (btnNm) {
            case "cmmnSearchBtn":
                getStlmList();
                break;
            case "cmmnExcelDownloadBtn":
                
                break;
            default: break;
        }
    };

    /* 날짜 선택 함수 */
    const handelDatePickerChange = (date, name) => {
      setSearchData((prevData) => ({
        ...prevData,
        [name]: getFormattedDate(date, "yyyy-MM-dd"),
      }));
    };

    
    const payYnArr = [
      {key:t("qrStlmMgtPage.normalPay"), value:"Y"},
      {key:t("qrStlmMgtPage.unNormalPay"), value:"N"}
    ];

    // Modal 관련
    const [rfdmModalOpen, setRfdmModalOpen] = useState(false);
    const [rfdmModalData, setRfdmModalData] = useState(null);
    const openRfdmModal = (data) => {
      setRfdmModalOpen(true);
      setRfdmModalData(data);
      lockScroll();
    };
    const closeRfdmModal = () => {
      setRfdmModalOpen(false);
      // alert과 Modal RefundModal간의 렌더링 타이밍 차이로 스크롤제어가 지속되서 타임아웃통해 강제로 제어 없애기
      setTimeout(() => { 
        document.body.style.overflow = 'unset';
        document.body.classList.remove('modal-open'); 
      }, 50);
      getStlmList();
      openScroll();
    };

    const lockScroll = useCallback(() => {
        document.body.style.cssText = `
                position: fixed;
                top: -${window.scrollY}px;
                overflow-y: scroll;
                width: 100%;
            `;
    }, []);

    const openScroll = useCallback(() => {
        const scrollY = document.body.style.top;
        document.body.style.cssText = '';
        window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    }, []);


    return (
        <>
        <MainSection>
            <TitleWrap>
                <div className="title">
                    <img src={Activity} alt={"QR결제내역"} />
                    <h2>{t("qrStlmMgtPage.qrPayList")}</h2>
                </div>
                <SearchOptionWrap>
                  <li>
                    <h3>{t("qrStlmMgtPage.deviceNm")}</h3>
                    <EqmtSelectBox // searchData에 eqmtID 가 찍힐텐데..
                      tagName={"eqmtId"}
                      defaultOptTxt={t("m_saleHistPage.entire")}
                      brchId={brchId}
                      onSelectChange={handleSearchDataChange}
                    />
                  </li>
                  {/* <li style={{display:'flex', flexDirection:'column', gap:'5px'}}> */}
                  <li className="dateSection">
                    <h3>{t("qrStlmMgtPage.period")}</h3>
                    <CustomDatePicker
                            defaultStartDate={searchData.startDate}
                            defaultEndDate={searchData.endDate}
                            onSelectChange={handelDatePickerChange}
                            isMobile={isMobile}
                        />
                    {/* <input type="date" className="basic-input w-100" />
                    ~
                    <input type="date" className="basic-input w-100"/> */}
                  </li>
                  <li>
                    <h3>{t("qrStlmMgtPage.division")}</h3>
                    <SelectBox 
                      defaultOptTxt={t("m_saleHistPage.entire")} 
                      dataArray={payYnArr}
                      onSelectChange={(e) => handleSearchDataChange(e, 'payYn')}
                      tagName="payYn"
                      />
                  </li>
                  <li>
                    <h3>{t("qrStlmMgtPage.status")}</h3>
                    <SelectBox 
                      defaultOptTxt={t("m_saleHistPage.entire")} 
                      dataArray={stlmStatArr}
                      onSelectChange={(e) => handleSearchDataChange(e, 'stlmStatCd')}
                      tagName="stlmStatCd"
                      />
                  </li>
                  <li>
                    <h3>{t("qrStlmMgtPage.payMethod")}</h3>
                    <SelectBox 
                      defaultOptTxt={t("m_saleHistPage.entire")}
                      dataArray={stlmMethArr}
                      onSelectChange={(e) => handleSearchDataChange(e, 'stlmMethCd')}
                      tagName="stlmMethCd"
                      />
                  </li>
                </SearchOptionWrap>
                <ButtonUtil
                        value={t("m_common.searchLable")}
                        className="btn btn-danger round-filled-small-btn"
                        name="cmmnSearchBtn"
                        onClick={() => { handleCmmnBtnClick("cmmnSearchBtn") }}
                    />
            </TitleWrap>
            <DashBoardWrap>
              <div className="stlm-box-list w-100">
                {stlmList && stlmList.map((data,idx) => (
                  <div className="dashboard-box stlm-box" key={idx}>
                    <div className="stlm-title">
                        <div className="stlm-num">
                            {idx+1}
                        </div>
                        <h2>{data.eqmtNm}</h2>
                    </div>
                    <div className="stlm-content">
                        <label htmlFor="stlm1">
                            {data.trxNo && (
                              <>
                                {t("qrStlmMgtPage.TransactionNum")}: {data.trxNo} <br/>
                              </>
                            )}
                            {t("qrStlmMgtPage.division")}: {data.stlmChk? t("qrStlmMgtPage.normalPay"):t("qrStlmMgtPage.unNormalPay")}<br/> {/* stlmChk의 여부를 판단 촬영이력에 cutmId가 없으면 stlmChk가 들어오지 않음.*/}
                            {t("qrStlmMgtPage.payAmt")}: ¥{data.stlmAmt} <br/>
                            {t("qrStlmMgtPage.payMethod")}: {data.stlmMethCd} <br/>
                            {t("qrStlmMgtPage.status")}: {stlmStatObj[data.stlmStatCd] ?? '알 수 없음'} <br/>
                            {t("qrStlmMgtPage.createDate")}: {convStlmDateString(data.stlmCrtnDdt)} <br/>
                            {t("qrStlmMgtPage.payDate")}: {convStlmDateString(data.stlmDdt)} <br/>
                        </label>
                    </div>
                    <ButtonUtil
                            value={t("qrStlmMgtPage.refund")}
                            className= {data.stlmStatCd === "captured" ? "btn btn-danger round-filled-small-btn" : "btn btn-secondery round-filled-gray-btn small-btn"}
                            name="cmmnRefundBtn"
                            disabled={data.stlmStatCd === "captured" ? false:true}
                            onClick={() => { openRfdmModal(data) }}
                        />
                  </div>
                ))}

                {/*
                 박스 1번
                <div className="dashboard-box stlm-box">
                  <div className="stlm-title">
                      <div className="stlm-num">
                          1
                      </div>
                      <h2>Hallyu Standard Blue1</h2>
                  </div>
                  <div className="stlm-content">
                      <label htmlFor="stlm1">
                          구분: 정상결제<br/>
                          결제금액: ¥600 <br/>
                          결제방법: Paypay <br/>
                          상태: 지불 <br/>
                          생성일시: 2025-11-12 13:20:11 <br/>
                          결제일시: 2025-11-12 13:20:11 <br/>
                      </label>
                  </div>
                  <ButtonUtil
                          value={t("qrStlmMgtPage.refund")}
                          className="btn btn-secondery round-filled-gray-btn small-btn"
                          name="cmmnRefundBtn"
                          onClick={() => { handleCmmnBtnClick("cmmnRefundBtn") }}
                      />
                </div>
                 */}

              </div>
            </DashBoardWrap>

        </MainSection>
        <StlmRefundModal
            show={rfdmModalOpen}
            data={rfdmModalData}
            onHide={closeRfdmModal}
            t={t}
        />
        </>
    );
}